import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
// eslint-disable-next-line
import CustomerProfileEditStatisticsFieldTitle from '../../components/CustomerProfileEditStatisticsFieldTitle/CustomerProfileEditStatisticsFieldTitle';
import { customerProfileEditStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { SCREENS } from '~/constants/screens';
import { dashboardPreventId } from '~/view/screens/DashboardScreen/constants/dashboard';

const CustomerProfileEditWallet: FC = observer((): JSX.Element => {
  const { customer, loading, updateWallet } = customerProfileEditStore;

  const openWalletEditModal = useCallback(() => {
    if (!customer) return;
    modalStore.openCustomerWalletModal({ customerId: customer.id, currentWalletsNumber: customer.wallet, onSave: updateWallet });
  }, [customer]);

  return (
    <div className="d-flex flex-column">
      <Text type={TEXT.SECTION_HEADER} text="wallet" />

      <div className="d-flex flex-column mt-4 gap-30">
        <div className="customer-profile-edit__statistic-field">
          <CustomerProfileEditStatisticsFieldTitle title="current_balance" />
          {customer ? (
            <Link id={dashboardPreventId} to={SCREENS.USER_WALLET_TRANSACTION_LOG(customer.id)}>
              <span id={dashboardPreventId} className="dashboard-plate__link">
                {customer.wallet || '-'}
              </span>
            </Link>
          ) : (
            <Skeleton width={30} height={19.2} />
          )}
        </div>

        <Button title={localeStore.t('update_wallet')} onClick={openWalletEditModal} loading={loading} appearance="secondary" />

        {customer ? (
          <Link id={dashboardPreventId} to={SCREENS.USER_WALLET_TRANSACTION_LOG(customer.id)}>
            <span id={dashboardPreventId} className="dashboard-plate__link">
              {localeStore.t('wallet_log')}
            </span>
          </Link>
        ) : (
          <Skeleton width={30} height={19.2} />
        )}
      </div>
    </div>
  );
});

export default CustomerProfileEditWallet;
